module.exports = __webpack_public_path__ + "static/media/StarWars-icon.12107ee4.svg";